export const spSearch = {
  spSearchDialog: {
    title: "Find Compatible Parts",
    subTitle: "Identify your model to see compatible parts only.",
    modelNumber: "Model #",
    serialNumber: "Serial Number #",
    whereFindSerialNumber: "Where do I find my serial number?",
    serialNumberLocation: "The data plate is typically located on the side of the unit near the control panel.",
    serialNumberHint: "Serial Number is required for \"QT\", \"RTS\", \"HTS\" models",
    viewParts: "View Parts",
  }
};